export default "__VITE_ASSET__CPTrympd__"